import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { AddCompanyComponent } from './features/company/add-company/add-company.component';
import { LoginComponent } from './features/auth/login/login.component';
import { NotFoundComponent } from './features/public/not-found/not-found.component';
import { SubscriberLoginComponent } from './features/auth/subscriber-login/subscriber-login.component';
import { SubscriberSignupComponent } from './features/auth/subscriber-signup/subscriber-signup.component';
import { ViewCompanyComponent } from './features/company/view-company/view-company.component';
import { SubscriberForgotPasswordComponent } from './features/auth/subscriber-forgot-password/subscriber-forgot-password.component';
import { AcceptInvitationComponent } from './features/auth/accept-invitation/accept-invitation.component';
import { ForgotPasswordComponent } from './features/auth/forgot-password/forgot-password.component';
import { LandingPageComponent } from './features/public/front-end/web-pages/landing-page/landing-page.component';
import { AboutUsComponent } from './features/public/front-end/web-pages/about-us/about-us.component';
import { ContactUsComponent } from './features/public/front-end/web-pages/contact-us/contact-us.component';
import { PricingComponent } from './features/public/front-end/web-pages/pricing/pricing.component';
import { PaymentComponent } from './features/public/front-end/web-pages/payment/payment.component';
import { TermsAndConditionsComponent } from './features/public/front-end/web-pages/termsAndConditions/termsAndConditions.component';
import { PrivacyPolicyComponent } from './features/public/front-end/web-pages/privacyPolicy/privacyPolicy.component';
import { ShippingAndDeliveryComponent } from './features/public/front-end/web-pages/shipping-and-delivery/shipping-and-delivery.component';
import { CancellationAndRefundComponent } from './features/public/front-end/web-pages/cancellation-and-refund/cancellation-and-refund.component';
import { BlogLoginComponent } from './features/public/blog/blog-login/blog-login.component';
import { AddBlogComponent } from './features/public/blog/add-blog/add-blog.component';
import { ViewBlogComponent } from './features/public/blog/view-blog/view-blog.component';
import { EnquiryComponent } from './features/public/front-end/web-pages/enquiry/enquiry.component';
import { ThankYouComponent } from './features/public/front-end/web-pages/thank-you/thank-you.component';
import { QrMenuComponent } from './features/public/front-end/web-pages/qr-menu/qr-menu.component';

export const routes: Routes = [
  { path: '', component: LandingPageComponent, canActivate: [AuthGuard], pathMatch: 'full' },
  { path: 'subscriber-signup', component: SubscriberSignupComponent },
  { path: 'subscriber-login', component: SubscriberLoginComponent },
  { path: 'subscriber-login/:subscriberID', component: SubscriberLoginComponent },
  { path: 'view-company', component: ViewCompanyComponent, canActivate: [AuthGuard] },
  { path: 'add-company', component: AddCompanyComponent, canActivate: [AuthGuard] },
  { path: 'login', component: LoginComponent, canActivate: [AuthGuard] },
  { path: 'subscriber-forgot-password', component: SubscriberForgotPasswordComponent },
  { path: 'accept-invitation/:token', component: AcceptInvitationComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'about-us', component: AboutUsComponent },
  { path: 'contact-us', component: ContactUsComponent },
  { path: 'pricing', component: PricingComponent },
  { path: 'payment', component: PaymentComponent },
  { path: 'enquiry', component: EnquiryComponent },
  { path: 'thank-you', component: ThankYouComponent },
  { path: 'termsAndConditions', component: TermsAndConditionsComponent },
  { path: 'privacyPolicy', component: PrivacyPolicyComponent },
  { path: 'shipping-and-delivery', component: ShippingAndDeliveryComponent },
  { path: 'cancellation-and-refund', component: CancellationAndRefundComponent },
  { path: 'blog-login', component: BlogLoginComponent },
  { path: 'add-blog', component: AddBlogComponent, canActivate: [AuthGuard] },
  { path: 'view-blog', component: ViewBlogComponent, canActivate: [AuthGuard] },
  { path: 'qr-menu/:companyId/:financialYear', component: QrMenuComponent },
  {
    path: 'admin',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./features/admin/admin.routes').then((m) => m.adminRoutes),
  },
  { path: '**', component: NotFoundComponent },
];
